<div id="OperatorBadge" class="p-2 bg-secondary text-white">{{'Act on behalf of a whistleblower' | translate}}.</div>
